// src/components/TrialCountdownBanner.jsx
import React from 'react';

const TrialCountdownBanner = ({ daysRemaining, isExpired, isMobile = false }) => {
  // Hide banner completely on mobile devices
  if (isMobile) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: isMobile ? '60px' : 0, // Below mobile header on mobile
      left: isMobile ? 0 : '250px', // Full width on mobile, after sidebar on desktop
      right: 0,
      backgroundColor: isExpired ? 'white' : '#243665',
      color: isExpired ? '#243665' : 'white',
      padding: isMobile ? '10px 16px' : '12px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      flexWrap: 'wrap',
      gap: isMobile ? '8px' : '12px',
      borderBottom: isExpired ? '2px solid #243665' : '1px solid rgba(255,255,255,0.1)',
      boxSizing: 'border-box',
      zIndex: 100
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? '8px' : '12px',
        flex: 1,
        minWidth: isMobile ? '150px' : '200px'
      }}>
        {/* Gem Icon */}
        <img 
          src={require('../assets/images/gem.gif')}
          alt="Premium" 
          style={{
            width: isMobile ? '24px' : '32px',
            height: isMobile ? '24px' : '32px',
            flexShrink: 0
          }}
        />
        
        {/* Message */}
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '600',
            marginBottom: '2px',
            color: isExpired ? '#243665' : 'white'
          }}>
            {isExpired 
              ? "Trial Expired" 
              : daysRemaining === 0 
                ? "Trial ends today" 
                : `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} left`
            }
          </div>
          {!isMobile && (
            <div style={{
              fontSize: '13px',
              opacity: 0.9,
              color: isExpired ? '#243665' : 'white'
            }}>
              {isExpired 
                ? "Upgrade now to continue creating and editing allocations"
                : "Choose a plan to continue using Pitchallo after your trial ends"
              }
            </div>
          )}
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        gap: '8px',
        flexShrink: 0
      }}>
        {/* Only show "View Plans" button when trial is active (not expired) and not on mobile */}
        {!isExpired && !isMobile && (
          <button
            onClick={() => window.location.href = '/pricing'}
            style={{
              padding: '8px 16px',
              backgroundColor: 'white',
              color: '#243665',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              transition: 'transform 0.2s',
            }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          >
            View Plans
          </button>
        )}
        
        <button
          onClick={() => window.location.href = '/pricing'}
          style={{
            padding: isMobile ? '6px 12px' : '8px 16px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: isMobile ? '12px' : '13px',
            fontWeight: '600',
            whiteSpace: 'nowrap',
            transition: 'transform 0.2s, box-shadow 0.2s',
            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.05)';
            e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.3)';
          }}
        >
          Upgrade
        </button>
      </div>
    </div>
  );
};

export default TrialCountdownBanner;
